import { Injectable } from '@angular/core';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../../catalog-search-criteria';
import { AllocationViewListSearchCriteria, AllocationViewUli } from '../models';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import {
  AllocationDriverViewListLoad,
  AllocationViewListInitialState,
  AllocationViewListLoad,
} from './allocation-view-list.actions';
import { combineLatest, Observable, of } from 'rxjs';
import { AllocationViewListState, AllocationViewListStateModel } from './allocation-view-list.state';
import { HubContextFacade } from '../../../administration/hub/context/hub-context.facade';
import { HubBrief } from '../../../administration/hub/models/hub.model';
import { filter, switchMap, take } from 'rxjs/operators';
import { convertTimeFrameFilterToUTC } from '../utils';

@Injectable({ providedIn: 'root' })
export class AllocationViewListFacade {
  listDto$: Observable<AllocationViewListStateModel> = this.store.select(AllocationViewListState.getState);
  items$: Observable<AllocationViewUli[]> = this.store.select(AllocationViewListState.getItems);
  loaded$: Observable<boolean> = this.store.select(AllocationViewListState.getLoaded);

  constructor(
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
    private hubContextFacade: HubContextFacade,
    private store: Store,
    private actions: Actions,
  ) {}

  loadAll(): Observable<ActionCompletion<unknown, Error>> {
    this.hubContextFacade.selectedHub$
      .pipe(
        filter(Boolean),
        switchMap((hub: HubBrief) =>
          combineLatest([
            of(hub),
            this.catalogSearchCriteriaFacade.getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.AllocationView),
          ]),
        ),
        take(1),
      )
      .subscribe(([hubBrief, allocationViewSearchCriteria]: [HubBrief, AllocationViewListSearchCriteria]) => {
        const { id, timezone } = hubBrief;
        const timeFrame = convertTimeFrameFilterToUTC(allocationViewSearchCriteria.timeFrame, timezone);
        this.store.dispatch(
          new AllocationViewListLoad({
            ...allocationViewSearchCriteria,
            timeFrame,
            hubId: id,
          }),
        );
      });

    return this.actions.pipe(ofActionCompleted(AllocationViewListLoad));
  }

  loadDriverViewList(payload: { uliId: number; endDate: number; startDate: number }): void {
    this.store.dispatch(new AllocationDriverViewListLoad(payload));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewListInitialState());
  }
}
